import { FC, useState } from 'react';
import { TableListQueryResponse } from '../../../../_core/interfaces/table-list-query.interface';
import { SurveyAnswerDto } from '@families-link/shared';
import { useTranslation } from 'react-i18next';
import { useReactTable, getCoreRowModel, SortingState, getSortedRowModel } from '@tanstack/react-table';
import { CoreTable, CoreTableEmptyBody } from '../../../../_core/components/_ui/core-table';
import { useUnrecognizedSurveyAnswersTableColumns } from '../../../hooks/table-columns/families-unrecognized-answers-table-colums.hook';

export interface UnrecognizedSurveyAnswersTableHandlers {
	onAttachFamily(surveyAnswer: SurveyAnswerDto): void;
	onDelete(surveyAnswer: SurveyAnswerDto): void;
	onView(surveyAnswer: SurveyAnswerDto): void;
}

type UnrecognizedSurveyAnswersTableProps = TableListQueryResponse<SurveyAnswerDto> &
	UnrecognizedSurveyAnswersTableHandlers;

export const UnrecognizedSurveyAnswersTable: FC<UnrecognizedSurveyAnswersTableProps> = (props) => {
	const { data, loading, hasMore, fetchMore, scrollRef, onAttachFamily, onDelete, onView } = props;

	const [t] = useTranslation();
	const [sorting, setSorting] = useState<SortingState>([]);

	const columns = useUnrecognizedSurveyAnswersTableColumns({
		onAttachFamily,
		onDelete,
		onView,
	});

	const table = useReactTable<SurveyAnswerDto>({
		data,
		columns,
		state: {
			sorting,
		},
		onSortingChange: setSorting,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			hasMore={hasMore}
			threshold={200}
			emptyListComponent={
				<CoreTableEmptyBody label={t('profile.sessions.table.empty-title')} description={t('families.no-families')} />
			}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={table.getHeaderGroups()}
		/>
	);
};
